module.exports = __webpack_public_path__ + "assets/img/ic-NBmoney.40421121.svg";